"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsDetailRequest = void 0;
var NewsDetailRequest = /** @class */ (function () {
    function NewsDetailRequest() {
    }
    return NewsDetailRequest;
}());
exports.NewsDetailRequest = NewsDetailRequest;
;
//# sourceMappingURL=newsDetail.request.js.map